import {reduce} from "lodash/fp";

import {createFetchReducer} from "@atg-shared/fetch-redux";

import {
    REQUEST_SPORT_JACKPOT,
    RECEIVE_SPORT_JACKPOT,
    RESET_JACKPOT,
} from "./jackpotActions";

import type {JackpotState} from "./jackpot";
import type {Action} from "./jackpotActions";

const DEFAULT_STATE: JackpotState = {};

const jackpotReducer = createFetchReducer(
    REQUEST_SPORT_JACKPOT,
    RECEIVE_SPORT_JACKPOT,
    RESET_JACKPOT,
    (state: JackpotState = DEFAULT_STATE, action: Action) => {
        switch (action.type) {
            case RECEIVE_SPORT_JACKPOT: {
                if (!action.error && action.payload) {
                    return reduce(
                        (newState, offering) => {
                            if (offering.pool.expectedJackpot > 0) {
                                return {
                                    ...newState,
                                    [offering.id]: offering.pool.expectedJackpot,
                                };
                            }
                            return {...newState};
                        },
                        state,
                        action.payload,
                    );
                }
                return state;
            }
            default:
                return state;
        }
    },
    {},
);

export default jackpotReducer;
